// extracted by mini-css-extract-plugin
module.exports = {"DocumentOverview":"DocumentOverview__2S5BO","DocumentOverview_card":"DocumentOverview_card__2S5BO","DocumentOverview_pagination":"DocumentOverview_pagination__2S5BO"};